import gql from 'graphql-tag';

export default gql`
  query findCourseInfoByIdsQuery($ids: [MongoID!]) {
    findCourseInfoByIdsQuery(ids: $ids) {
      courseId
      courseCategories {
        _id
        title
        id
      }
      teachers {
        _id
        login
        firstName
        lastName
      }
    }
  }
`;
